import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function PasswordInput({
  label,
  name,
  register,
  validation,
  errors = {},
  placeholder,
  autoComplete = "off",
  inputClassName = "w-full pr-10 border rounded px-3 py-2",
  wrapperClassName = "form-field mt-4",
  labelClassName = "",
  containerClassName = "relative flex items-center",
  errorClassName = "text-red-500 text-sm mt-1",
  className = "",
  id,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const fieldId = id || name;

  const {
    onChange: propOnChange,
    onBlur: propOnBlur,
    ref: propRef,
    ...restProps
  } = props;

  const registerProps = register ? register(name, validation) : {};

  const {
    onChange: registerOnChange,
    onBlur: registerOnBlur,
    ref: registerRef,
    ...restRegisterProps
  } = registerProps;

  const handleChange = (event) => {
    registerOnChange?.(event);
    propOnChange?.(event);
  };

  const handleBlur = (event) => {
    registerOnBlur?.(event);
    propOnBlur?.(event);
  };

  const handleRef = (element) => {
    if (typeof registerRef === "function") {
      registerRef(element);
    } else if (registerRef) {
      registerRef.current = element;
    }

    if (typeof propRef === "function") {
      propRef(element);
    } else if (propRef) {
      propRef.current = element;
    }
  };

  return (
    <div className={`${wrapperClassName} ${className}`.trim()}>
      <label htmlFor={fieldId} className={labelClassName}>
        {label}
      </label>

      <div className={containerClassName}>
        <input
          id={fieldId}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder || label}
          className={inputClassName}
          autoComplete={autoComplete}
          {...restProps}
          {...restRegisterProps}
          onChange={handleChange}
          onBlur={handleBlur}
          ref={handleRef}
        />

        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600"
          aria-label={showPassword ? `Hide ${label}` : `Show ${label}`}
          aria-pressed={showPassword}
        >
          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
        </button>
      </div>

      {errors?.[name]?.message && (
        <p className={errorClassName}>{errors[name].message}</p>
      )}
    </div>
  );
}
